export const ActiveToolbarItem = {
    LIGHTS: "LIGHTS",
    HUMIDITY: "HUMIDITY",
    HEATING: "HEATING",
    COLOURS: "COLOURS",
    TIMER: "TIMER",
};
